export default __webpack_public_path__ + "static/media/responses.5ad32ef5.svg";